import Navbar from './NavBar.js';

(function () {
    "use strict";

    const selectors = {
        navbar: '[data-cmp-is="navbar"]',
    };

    const initializeNavBar = () => {
        const elements = document.querySelectorAll(selectors.navbar);
        elements.forEach(element => new Navbar({ element }));

        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                const nodesArray = Array.from(mutation.addedNodes);
                nodesArray.forEach(addedNode => {
                    if (addedNode.querySelectorAll) {
                        const elementsArray = Array.from(addedNode.querySelectorAll(selectors.navbar));
                        elementsArray.forEach(element => new Navbar({ element }));
                    }
                });
            });
        });

        observer.observe(document.body, {
            subtree: true,
            childList: true,
            characterData: true
        });
    };

    if (document.readyState !== 'loading') {
        initializeNavBar();

    } else {
        document.addEventListener('DOMContentLoaded', initializeNavBar);
    }
})();